import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { setNavigate, NavigateOptions } from '@/utils/navigator';

const NavigationHandler: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Capture the hook and pass it to our utility
    // Now accepts options to support 'replace'
    setNavigate((path: string, options?: NavigateOptions) => {
        navigate(path, options);
    });
    //console.log('[NavigationHandler] Navigator initialized');
  }, [navigate]);

  return null; // Renders nothing
};

export default NavigationHandler;